import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Title from '../Title';
import ServiceItem from './ServiceItem';

const ServicesSection = styled.section`
  width: 100%;
  padding: 144px 210px 174px;
  background: #fff;
  text-align: center;

  @media only screen and (max-width: 1919px) {
    padding: 77px 193px 91px;
  }

  @media only screen and (max-width: 1365px) {
    padding: 84px 45px 66px;
  }

  @media only screen and (max-width: 1023px) {
    padding: 90px 125px 80px;
  }

  @media only screen and (max-width: 767px) {
    padding: 77px 16px 69px;
  }
`;

const ServicesCards = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-top: 111px;

  @media only screen and (max-width: 1919px) {
    margin-top: 97px;
  }

  @media only screen and (max-width: 1365px) {
    margin-top: 62px;
  }

  @media only screen and (max-width: 1023px) {
    flex-flow: column;
    justify-content: center;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 75px;
  }
`;

const serviceItems = [
  {
    icon: '/static/images/telephone/watch.svg',
    title: 'Будильник',
    desc: 'Наберите *181#, чтобы подключить услугу. Введите 4 цифры — время срабатывания будильника в часах и минутах.'
  },
  {
    icon: '/static/images/telephone/people.svg',
    title: 'Черный список',
    desc: 'Наберите *151#, чтобы подключить услугу. А если захотите ее отключить —  наберите в тональном режиме *150#.'
  },
  {
    icon: '/static/images/telephone/call.svg',
    title: 'Переадресация',
    desc: 'Наберите *174# и введите номер для переадресации. Переадресовать вызов можно на любой стационарный или мобильный телефон.'
  },
  {
    icon: '/static/images/telephone/done.svg',
    title: 'Бесплатный определитель номера',
    desc: 'Можно подключить и на смартфон, и на домашний телефон.'
  },
  {
    icon: '/static/images/telephone/timer.svg',
    title: 'Посекундная тарификация звонков',
    desc: 'Не переплачивайте за звонки. Вы будете знать стоимость каждой минуты.'
  },
  {
    icon: '/static/images/telephone/doc.svg',
    title: 'Подробная онлайн статистика',
    desc: 'Получите онлайн-доступ к полной расшифровке ваших звонков.'
  },
];

export default class Services extends Component {
  static propTypes = {
    title: PropTypes.string,
    text: PropTypes.string
  };

  render() {
    const { title, text, className } = this.props;

    const list = serviceItems.map((item, key) =>
      <ServiceItem
          key={key}
          icon={item.icon}
          title={item.title}
          desc={item.desc}
        />);
    return (
      <ServicesSection className={className}>
        <Title as='h2' title={title} text={text} />
        <ServicesCards>
          {list}
        </ServicesCards>
      </ServicesSection>
    );
  }
}
